import React from 'react';
import { IconProps } from './types';

export const CopyIcon = (props: IconProps) => {
  const { size = 16, color = 'currentColor', style = {} } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
    >
      <path
        fill={color}
        d='M20 8h-9c-1.7 0-3 1.3-3 3v9c0 1.7 1.3 3 3 3h9c1.7 0 3-1.3 3-3v-9c0-1.7-1.3-3-3-3zm1 12c0 .6-.4 1-1 1h-9c-.6 0-1-.4-1-1v-9c0-.6.4-1 1-1h9c.6 0 1 .4 1 1v9z'
      />
      <path
        fill={color}
        d='M5 14H4c-.3 0-.5-.1-.7-.3-.2-.2-.3-.4-.3-.7V4c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3h9c.3 0 .5.1.7.3.2.2.3.4.3.7v1c0 .6.4 1 1 1s1-.4 1-1V4c0-.8-.3-1.6-.9-2.1-.5-.6-1.3-.9-2.1-.9H4c-.8 0-1.6.3-2.1.9C1.3 2.4 1 3.2 1 4v9c0 .8.3 1.6.9 2.1.5.6 1.3.9 2.1.9h1c.6 0 1-.4 1-1s-.4-1-1-1z'
      />
    </svg>
  );
};
